<div [ngClass]="{ 'cursor-pointer': !disabled() }" (click)="disabled() || menu.toggle($event)">
    <ng-container *ngTemplateOutlet="target()"></ng-container>
</div>
<p-menu #menu [model]="items()" [popup]="true" styleClass="appDropDownMenu" [appendTo]="appendTo()"/>
